(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  (function() {
    function formatProductTitle(text) {
      const smallWords = ['de', 'del', 'la', 'las', 'el', 'los', 'y', 'en', 'para', 'con', 'of', 'the', 'and', 'a', 'an', 'to', 'for', 'in', 'on', 'by'];

      return text
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .split(' ')
        .map(function(word, index) {
          if (/^\d+(ml|g|kg|oz)$/i.test(word)) {
            return word.replace(/^(\d+)(ml|g|kg|oz)$/i, '$1 $2');
          }

          if (smallWords.indexOf(word) !== -1 && index !== 0) {
            return word;
          }

          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    }

    function updateCollectionTitles() {
      const titles = document.querySelectorAll(
        '.ProductItem__Title a, .boost-pfs-filter-product-item-title a'
      );

      titles.forEach(function(title) {
        if (title.dataset.fisenceTitleFormatted === 'true') {
          return;
        }

        const originalTitle = title.textContent;
        const formattedTitle = formatProductTitle(originalTitle);

        if (formattedTitle) {
          title.textContent = formattedTitle;
          title.dataset.fisenceTitleFormatted = 'true';
        }
      });
    }

    document.addEventListener('DOMContentLoaded', updateCollectionTitles);
    document.addEventListener('boost-pfs-filter-products-loaded', updateCollectionTitles);

    const observer = new MutationObserver(function() {
      updateCollectionTitles();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
